import { request } from "./client";

export function fetchDreamcastSpeakers() {
  return request("/speakers");
}

export function fetchDreamcastSpeakerContributorTypes() {
  return request("/contributor-types");
}

export function fetchDreamcastSpeakerById(id) {
  return request(`/speakers/${id}`);
}

export function createDreamcastSpeaker(body) {
  return request("/speakers", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateDreamcastSpeaker(id, body) {
  return request(`/speakers/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function fetchDreamcastSpeakerArchivedIntros(id) {
  return request(`/speakers/${id}/archived-intros`);
}

export function fetchDreamcastSpeakerIntros(id) {
  return request(`/speakers/${id}/intros`);
}

export function archiveDreamcastSpeakerIntro(speakerId, introId) {
  return request(`/speakers/${speakerId}/intros/${introId}`, {
    method: "PATCH",
    body: JSON.stringify({ archived: true }),
  });
}

export function unarchiveDreamcastSpeakerIntro(speakerId, introId) {
  return request(`/speakers/${speakerId}/intros/${introId}`, {
    method: "PATCH",
    body: JSON.stringify({ archived: false }),
  });
}

export function deleteDreamcastSpeakerIntro(speakerId, introId) {
  return request(`/speakers/${speakerId}/intros/${introId}`, {
    method: "DELETE",
  });
}

export function deleteDreamcastSpeakerIntros(speakerId, introUrls) {
  return request(`/speakers/${speakerId}/delete-intros`, {
    method: "POST",
    body: JSON.stringify({ introUrls }),
  });
}

export function deleteDreamcastSpeaker(speakerId) {
  return request(`/speakers/${speakerId}`, {
    method: "DELETE",
  });
}
